import { render, staticRenderFns } from "./bulk-message-template-create-bulk-message-dialog.vue?vue&type=template&id=d8bf9aca&"
import script from "./bulk-message-template-create-bulk-message-dialog.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-create-bulk-message-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports